import { Link } from "react-router-dom";

export interface CrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: CrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex flex-wrap items-center gap-2 text-xs text-foreground-500 md:text-sm">
        <li className="flex items-center gap-2">
          <Link to="/" className="transition-colors hover:text-primary-600">
            首页
          </Link>
          <span className="text-foreground-300">/</span>
        </li>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-2">
              {item.to && !isLast ? (
                <Link to={item.to} className="transition-colors hover:text-primary-600">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-800" : ""}>{item.label}</span>
              )}
              {!isLast && <span className="text-foreground-300">/</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}